import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { ReservationPluginInfo } from 'projects/qcloud-models/reservation-plugin/reservation-plugin-info';

@Injectable({
  providedIn: 'root'
})
export class ReservationPluginService {

  appBase: string;
  locationId: number;
  systemId: number;
  private recaptchaSiteKeyV3: string;

  reservationInfo: Observable<ReservationPluginInfo>;
  private reservationInfoSubject: Subject<ReservationPluginInfo>;

  setAppBase(appConfig: any) {
    this.appBase = appConfig.appBase;
    this.locationId = appConfig.locationId;
    this.systemId = appConfig.systemId;
  }

  constructor(private http: HttpClient) {
    this.reservationInfoSubject = new Subject<ReservationPluginInfo>();
    this.reservationInfo = this.reservationInfoSubject.asObservable();
  }

  public publishReservationInfo(data: ReservationPluginInfo) {
    this.reservationInfoSubject.next(data);
  }

  getReservationData(): Observable<ReservationPluginInfo> {
    return this.http.get<ReservationPluginInfo>(this.appBase +
      `api/${this.systemId}/${this.locationId}/reservation/plugin/all`);
  }

  createReservation(reservation: TicketReservationPlugin): Observable<string> {
    return this.http.post<string>(this.appBase +
      `api/${this.systemId}/${this.locationId}/reservation/plugin`, reservation);
  }

  bookReservationTime(reservation: TicketReservationPlugin): Observable<number> {
    return this.http.post<number>(this.appBase +
      `api/${this.systemId}/${this.locationId}/reservation/plugin/booktime`, reservation);
  }

  unbookReservationTime(reservation: TicketReservationPlugin, reservedCategoryCapacity: number): Observable<any> {
    return this.http.post(this.appBase +
      `api/${this.systemId}/${this.locationId}/reservation/plugin/unbooktime/${reservedCategoryCapacity}`,
      reservation);
  }

  getReservation(reservationGuid: string): Observable<TicketReservationPlugin> {
    return this.http.get<TicketReservationPlugin>(this.appBase + `api/reservation/guid/${reservationGuid}`);
  }

  setRecaptchaKey(recaptchaKey: string) {
    this.recaptchaSiteKeyV3 = recaptchaKey;
  }

  getRecaptchaKey() {
    return this.recaptchaSiteKeyV3;
  }

}
